<template>
  <div class="personal-page">
    <div class="container">
      <!-- 面包屑导航 -->
      <div class="breadcrumb">
        <span>{{ $t('首页') }}</span>
        <span>{{ $t('个人中心') }}</span>

      </div>

      <div class="content-box df jcsb">
        <div class="left-box">
          <!-- 个人等级信息 -->
          <div class="card1 pl-48">
            <div class="level-boxs">{{info.user_points_level}}</div>
            <div class="t1">
              {{ $t('当前等级') }} <span class="s1 mr-16">Lv{{ info.user_points_level }}</span> {{ $t('个人总积分') }}
              <span class="s2">{{ info.user_score }}</span>
            </div>
            <div class="t2 mt-23">{{ $t('勋章收集') }}
              <img :src="info.user_medal_front_icon_arr" style="max-height: 36px;" class="mr-16" mode="heightFix"
                    v-if="info.user_medal_front_icon_arr != ''">
                <img v-for="(image, index) in info.user_logo_front_icon_arr" :key="index" :src="image"
                    style="max-height: 36px;" class="mr-16" mode="heightFix">
                    
            </div>
          </div>
          <!-- 菜单 -->
          <div class="card2">
            <div class="item df aic" v-for="(item, index) in menuList" :key="index" @click="handleClick(item.id)"
              :class="{ 'active-item': item.id == menuIndex }">
              <span class="iconfont" :class="item.icon"></span>
              <span class="t1">{{ $t(item.title) }}</span>
            </div>

          </div>


        </div>
        <div class="right-box">
          <!-- 资料 -->
          <information v-if="menuIndex == 1" />

          <!-- 账号 -->
          <account v-if="menuIndex == 2" />

          <!-- 我的收藏 -->
          <collection v-if="menuIndex == 3" />

          <!-- 我的贡献值 -->
          <!-- <contribute v-if="menuIndex == 4" /> -->

          <!-- 我的文章  -->
          <articles v-if="menuIndex == 5" />

          <!-- 我的讨论 -->
          <discuss v-if="menuIndex == 6" :data="data" />

          <!-- 我的活动 -->
          <active v-if="menuIndex == 7" :data="data" />

          <!-- 我的订单 -->
          <Order v-if="menuIndex == 9" />
          <!-- 我的积分 -->
          <Points v-if="menuIndex == 8" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getscore } from "@api/usercenter";

import { getcommonData } from "@api/home";
// 引入订单组件
import Order from "@/views/personal/components/order.vue";
// 引入积分组件
import Points from "@/views/personal/components/points.vue";

import account from './components/account'
import information from './components/information'
import collection from './components/collection'
import contribute from './components/contribute'
import articles from './components/article'
import discuss from './components/discuss'
import active from './components/active'
import Cookies from 'js-cookie'

export default {
  name: "Personal",
  components: {
    Order,
    Points,
    account,
    information,
    collection,
    contribute,
    articles,
    discuss,
    active,
  },
  data() {
    return {
      menuIndex: 1,
      data: [],

      menuList: [
        {
          id:1,
          icon: "icon-a-xingzhuangjiehe5",
          title: "我的信息"
        },
        {
          id:2,
          icon: "icon-icon1",
          title: "我的账号"
        },
        {
          id:3,
          icon: "icon-shoucang",
          title: "我的收藏"
        },
        
        // {
        //   icon: "icon-jiangbei",
        //   title: "我的贡献值"
        // },
        {
          id:5,
          icon: "icon-a-svg1",
          title: "我的文章"
        },
        {
          id:6,
          icon: "icon-xiaoxi1",
          title: "我的讨论"
        },
        {
          id:7,
          icon: "icon-icon7",
          title: "我的活动"
        },
      
        {
          id:8,
          icon: "icon-a-svg2",
          title: "我的积分"
        },
        {
          id:9,
          icon: "icon-ic_cart_lined",
          title: "我的订单"
        },

      ],

      info:{},
    }
  },
  created() {
    if (!Cookies.get('accessToken')) {
      this.$router.replace('/');
      return;
    }
    const datas = {
      tre_ep: "tre_ep",
    }

    this.insertScript("/static/raffle/index.js", JSON.stringify(datas), function () {
    })


    setTimeout(() => {
      this.$bus.$emit('changeNavbg', 'rgba(255, 255, 255, 1);');
    }, 600);

    this.getData();
  },

  methods: {


    handleClick(id) {
      this.menuIndex = id;
      // 整个页面滚动到顶部
      this.$nextTick(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        
      });
    },

    async getData() {
      let res = await getcommonData();
      if (res.status == 200) {
        this.data = res.data;
      }

      // 获取个人信息和jifen
      getscore({}).then((res) => {
                if (res.status == 200) {
                    this.info = res.data.info;
                }
            });


    },

    insertScript(path, data, callback) {
      var new_element = document.createElement("script");
      new_element.setAttribute("type", "text/javascript");
      new_element.setAttribute("src", path);
      new_element.setAttribute("data-param", data);
      new_element.onload = callback; // 加载完成后调用回调
      document.body.appendChild(new_element);
    }

  }
};
</script>

<style lang="scss" scoped>
.content-box {
  margin-top: 12px;

  .left-box {
    width: 325px;

    .card2 {
      margin-top: 16px;
      width: 100%;
      border-radius: 8px;
      box-shadow: -2px 0px 12px 0px rgba(0, 0, 0, 0.08);
      padding: 13px 20px;
      border: 1px solid #f3f3f3;

      .item {
        padding: 16px 12px;
        margin-top: 8px;
        border-radius: 4px;
        font-family: "harmonyos";
        transition: all .16s;
        cursor: pointer;

        &.active-item,
        &:hover {
          background: #FCF4F3;

          .t1,
          .iconfont {
            color: #D80F05;
          }
        }

        &:first-child {
          margin-top: 0;
        }

        .iconfont {
          font-size: 20px;
          line-height: 24px;
          position: relative;
          top: 2px;
          transition: all .16s;
        }

        .t1 {
          margin-left: 12px;
          line-height: 24px;
          color: #191919;
          transition: all .16s;
        }
      }
    }

    .card1 {
      width: 325px;
      min-height: 374px;
      border: 1px solid rgb(243, 243, 243);
      border-radius: 8px;
      box-shadow: -2px 0px 12px 0px rgba(101, 41, 41, 0.08);
      background-image: url("../../assets/images/img/card.png");
      background-repeat: no-repeat;
      padding-top: 269px;
      padding-bottom: 24px;
      position: relative;

      .level-boxs {
        color: #ffffff;
        position: absolute;
        font-size: 48px;
        font-family: "montserrat";
        font-size: 48px;
        font-weight: 700;
        line-height: 48px;
        width: 100%;
        text-align: center;
        left: 0;
        top: 88px;
      }

      .t1 {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0px;
        color: #191919;

        .s1 {
          color: #a83328;
        }

        .s2 {
          color: #285f9f;
        }
      }

      .t2 {
        color: rgb(25, 25, 25);

        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
      }
    }
  }

  .right-box {
    width: calc(100% - 341px);
    margin-left: 16px;
    border: 1px solid rgba(243, 243, 243, 1);
    border-radius: 8px;
    box-shadow: -2px 0px 12px 0px rgba(0, 0, 0, 0.08);
    padding: 24px 40px;
  }
}

.breadcrumb {
  span {
    font-size: 16px;
    line-height: 24px;
    color: #191919;

    &::after {
      content: "/";
      margin: 0 4px;
      font-size: 14px;
      color: #939393;
      position: relative;
      top: -1.5px;
    }

    &:first-child {
      color: #939393;
    }

    &:last-child {
      &::after {
        content: "";
      }
    }
  }
}

.personal-page {
  padding: 60px 80px 45px;

  .container {
    padding-top: 8px;
    max-width: 1400px;
    margin: 0 auto;
  }
}
</style>